require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-relazioni-e-conferenze-nicola-navone-franco-ponti-lugano-7-dicembre-2018.json") })
        }
      }, "path---en-relazioni-e-conferenze-nicola-navone-franco-ponti-lugano-7-dicembre-2018");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-relazioni-e-conferenze-nicola-navone-franco-ponti-lugano-7-dicembre-2018!./.cache/json/en-relazioni-e-conferenze-nicola-navone-franco-ponti-lugano-7-dicembre-2018.json
// module id = 638
// module chunks = 231608221292675